<div class="chat-tools-container">
    <div class="chatbox-prompts-container">
        <div class="chatbox-container">
            <div class="textarea-floater">
                <epd-input-group class="input-group" [suffixTemplate]="suffixTemplateInfoClose">
                    <epd-textarea
                        #queryInput
                        [value]="userQuery"
                        placeholder="Ask a question or select a question to edit from the sample prompts"
                        [rows]="2"
                        [maxRows]="10"
                        (input)="onUserQueryChange(queryInput.value)"
                        (keydown)="onUserQueryKeydown($event)"
                    ></epd-textarea>
                </epd-input-group>

                <ng-template #suffixTemplateInfoClose>
                    <epd-icon
                        class="close-button"
                        size="small"
                        type="x-remove"
                        *ngIf="!isSubmitInProgress && userQuery"
                        (click)="clearUserQuery()"
                    ></epd-icon>
                    <epd-icon
                        class="send-button"
                        size="small"
                        type="send"
                        *ngIf="!isSubmitInProgress"
                        (click)="submit()"
                    ></epd-icon>
                    <epd-icon
                        class="abort-button"
                        size="small"
                        type="x-close"
                        *ngIf="isSubmitInProgress"
                        (click)="abortQuery()"
                    ></epd-icon>
                </ng-template>
            </div>
        </div>
        <craig-streaming-prompt-ideas (promptUpdated)="handlePromptUpdate($event)"></craig-streaming-prompt-ideas>
    </div>

    <!-- Debug component for realtime streaming -->
    <!-- <craig-realtime-session-stream></craig-realtime-session-stream> -->
</div>
